module.exports = __webpack_public_path__ + "img/3.bc5beac8.svg";